/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import {
  getConfig,
  getPanel,
  getPanelVisiblity,
  getShouldShowProximityView,
  getIsPanelAutoHideEnabled,
  getPanelProps
} from "../../selectors/bottomBoardSelectors";
import BottomPanelView from "components/bottomBoard/BottomPanelView";
import { bottomBoardHideManager } from "utils/ComponentHideManager";

const mapStoreToProps = stores => ({
  showPanel: getPanelVisiblity(stores),
  panelDropinId: getPanel(stores),
  config: getConfig(stores),
  onInvisibleDivHover: () => {
    stores.bottomBoard.setPanelVisibility(true);
  },
  panelProps: getPanelProps(stores),
  setIsBottomPanelLoaded: value => {
    if (!getIsPanelAutoHideEnabled(stores)) {
      return;
    }
    value ? bottomBoardHideManager.resurfaceBoard() : bottomBoardHideManager.reset();
  },
  showProximityView: getShouldShowProximityView(stores),
  setBottomPanelRect: bottomPanelRect => stores.bottomBoard.setBottomPanelRect(bottomPanelRect)
});

const BottomPanelContainer = inject(mapStoreToProps)(BottomPanelView);

export default BottomPanelContainer;
